import { FormEvent, useState } from 'react';
import { Button, TextField, Typography } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import { useNavigate } from 'react-router-dom';
import { useAskAiStyles } from './askAiStyles';

const SUGGESTIONS = [
  { label: 'Find product documentation', query: 'product documentation' },
  { label: 'Explore our teams', query: 'teams' },
  { label: 'Find onboarding guides', query: 'onboarding' },
];

/** The drawer for everyone without codebase access: search Univerus Central. */
export function AskAiSearch({ onClose }: { onClose: () => void }) {
  const classes = useAskAiStyles();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!query.trim()) return;
    navigate(`/search?query=${encodeURIComponent(query.trim())}`);
    onClose();
  };
  return (
    <>
      <Typography component="h3" className={classes.title}>
        What would you like to do?
      </Typography>
      <p className={classes.description} id="ask-ai-description">
        Find the knowledge, products and people you need to move forward.
      </p>
      <form className={classes.form} onSubmit={submit}>
        <TextField
          id="ask-ai-query"
          fullWidth
          variant="outlined"
          label="What are you looking for?"
          value={query}
          onChange={event => setQuery(event.target.value)}
        />
        <div className={classes.suggestions}>
          {SUGGESTIONS.map(({ label, query: suggestion }) => (
            <Button
              key={label}
              variant="outlined"
              onClick={() => setQuery(suggestion)}
            >
              {label}
            </Button>
          ))}
        </div>
        <Button
          type="submit"
          disabled={!query.trim()}
          color="primary"
          variant="contained"
          startIcon={<Search />}
        >
          Search Univerus Central
        </Button>
      </form>
    </>
  );
}
